// src/category.ts
const STATIQUE = "STATIQUE";
const BAR = "BAR";
const MANUTENTION = "MANUTENTION";
const FUN = "FUN";
const RELOU = "RELOU";
const COLLAGE = "COLLAGE";
const taskCategories = [
	STATIQUE,
	"BAR",
	MANUTENTION,
	"FUN",
	RELOU,
	COLLAGE
];
// src/action.ts
const CREATED = "CREATED";
const COMMENTED = "COMMENTED";
const READY_TO_REVIEW = "READY_TO_REVIEW";
const APPROVED = "APPROVED";
const REJECTED = "REJECTED";
const RESET_REVIEW = "RESET_REVIEW";
const ASSIGNMENT_STARTED = "ASSIGNMENT_STARTED";
const FORCED_UPDATE = "FORCED_UPDATE";
// src/review.ts
const REVIEWING = "REVIEWING";
const NOT_ASKING_TO_REVIEW = "NOT_ASKING_TO_REVIEW";
const WILL_NOT_REVIEW = "WILL_NOT_REVIEW";
const A_RELIRE = "À relire";
const REJETEE = "Rejetée";
const APPROUVEE = "Approuvée";
const PAS_DE_RELECTURE = "Pas de relecture";
const NE_VA_PAS_RELIRE = "Ne va pas relire";
const reviewLabels = /* @__PURE__ */ new Map([
	[REVIEWING, A_RELIRE],
	[APPROVED, APPROUVEE],
	[REJECTED, REJETEE],
	[NOT_ASKING_TO_REVIEW, PAS_DE_RELECTURE],
	[WILL_NOT_REVIEW, NE_VA_PAS_RELIRE]
]);
// src/status.ts
const DRAFT = "DRAFT";
const IN_REVIEW = "IN_REVIEW";
const VALIDATED = "VALIDATED";
const REFUSED = "REFUSED";
const READY_TO_ASSIGN = "READY_TO_ASSIGN";
const BROUILLON = "Brouillon";
const RELECTURE_EN_COURS = "Relecture en cours";
const VALIDEE = "Validée";
const REFUSEE = "Refusée";
const PRETE_POUR_AFFECTATION = "Prête pour affectation";
const statusLabels = /* @__PURE__ */ new Map([
	[DRAFT, BROUILLON],
	[IN_REVIEW, RELECTURE_EN_COURS],
	[REFUSED, REFUSEE],
	[VALIDATED, VALIDEE],
	[READY_TO_ASSIGN, PRETE_POUR_AFFECTATION]
]);
// src/mobilization.ts
const ALL_TEAM_MEMBERS = -1;
// src/drive-location.ts
const MAGASIN = "Magasin";
const LIVRE_PAR_LOGISTIQUE = "Livré par l'équipe logistique";
const LIVRE_PAR_TEAM_ELEC = "Livré par l'équipe élec";
const LIVRE_PAR_BAR = "Livré par l'équipe bar";
const LIVRE_PAR_COM = "Livré par une com";
const BENNE_COLLETTE_BESSON = "Benne Collette Besson";
const BENNE_PARKING_K_FET = "Benne Parking K-fet";
const PARKING_EIFFEL = "Parking Eiffel";
const CREUX_GCU = "Creux GCU";
const CREUX_GM = "Creux GM";
const CAVE_E = "Cave E";
const CAVE_BIKERS = "Cave des Bikers";
const CLUB_ROCK = "Club Rock";
const CONTENUR_24H = "Conteneur 24h";
const CONTENEUR_KARNA = "Conteneur Karna";
const CONTENEUR_PARKING_K_FET = "Conteneur Parking K-fet";
const CONTENEUR_SCENE_PULSE = "Conteneur Scène Pulse";
const HALL_DES_HUMANITES = "Hall des Humanités";
const LOCAL_24H = "Local 24h";
const MDE = "MdE";
const SALLE_MONTREAL = "Salle Montréal";
const SALLE_RENE_CHAR = "Salle René Char";
const NON_STOCKE = "Non stocké";
const QG_ORGA = "QG Orga";
const BACKLINE = "Backline";
const SALLE_CRLA = "Salle CRL-A Humanités";
const SALLE_CRLB = "Salle CRL-B Humanités";
const drives = [
	MAGASIN,
	LIVRE_PAR_LOGISTIQUE,
	LIVRE_PAR_TEAM_ELEC,
	LIVRE_PAR_BAR,
	LIVRE_PAR_COM,
	BENNE_COLLETTE_BESSON,
	BENNE_PARKING_K_FET,
	PARKING_EIFFEL,
	CREUX_GCU,
	CREUX_GM,
	CAVE_E,
	CAVE_BIKERS,
	CLUB_ROCK,
	CONTENUR_24H,
	CONTENEUR_KARNA,
	CONTENEUR_PARKING_K_FET,
	CONTENEUR_SCENE_PULSE,
	HALL_DES_HUMANITES,
	LOCAL_24H,
	"MdE",
	SALLE_MONTREAL,
	SALLE_RENE_CHAR,
	NON_STOCKE,
	QG_ORGA,
	BACKLINE,
	SALLE_CRLA,
	SALLE_CRLB
];
// src/electricity-connection.ts
const PC16_Prise_classique = "PC16_Prise_classique";
const P17_16A_MONO = "P17_16A_MONO";
const P17_16A_TRI = "P17_16A_TRI";
const P17_16A_TETRA = "P17_16A_TETRA";
const P17_32A_MONO = "P17_32A_MONO";
const P17_32A_TRI = "P17_32A_TRI";
const P17_32A_TETRA = "P17_32A_TETRA";
const P17_63A_MONO = "P17_63A_MONO";
const P17_63A_TRI = "P17_63A_TRI";
const P17_63A_TETRA = "P17_63A_TETRA";
const P17_125A_TETRA = "P17_125A_TETRA";
const electricityConnections = [
	PC16_Prise_classique,
	P17_16A_MONO,
	P17_16A_TRI,
	P17_16A_TETRA,
	P17_32A_MONO,
	P17_32A_TRI,
	P17_32A_TETRA,
	P17_63A_MONO,
	P17_63A_TRI,
	P17_63A_TETRA,
	P17_125A_TETRA
];
export { ALL_TEAM_MEMBERS, APPROUVEE, APPROVED, ASSIGNMENT_STARTED, A_RELIRE, BACKLINE, BAR, BENNE_COLLETTE_BESSON, BENNE_PARKING_K_FET, BROUILLON, CAVE_BIKERS, CAVE_E, CLUB_ROCK, COLLAGE, COMMENTED, CONTENEUR_KARNA, CONTENEUR_PARKING_K_FET, CONTENEUR_SCENE_PULSE, CONTENUR_24H, CREATED, CREUX_GCU, CREUX_GM, DRAFT, FORCED_UPDATE, FUN, HALL_DES_HUMANITES, IN_REVIEW, LIVRE_PAR_BAR, LIVRE_PAR_COM, LIVRE_PAR_LOGISTIQUE, LIVRE_PAR_TEAM_ELEC, LOCAL_24H, MAGASIN, MANUTENTION, MDE, NE_VA_PAS_RELIRE, NON_STOCKE, NOT_ASKING_TO_REVIEW, P17_125A_TETRA, P17_16A_MONO, P17_16A_TETRA, P17_16A_TRI, P17_32A_MONO, P17_32A_TETRA, P17_32A_TRI, P17_63A_MONO, P17_63A_TETRA, P17_63A_TRI, PARKING_EIFFEL, PAS_DE_RELECTURE, PC16_Prise_classique, PRETE_POUR_AFFECTATION, QG_ORGA, READY_TO_ASSIGN, READY_TO_REVIEW, REFUSED, REFUSEE, REJECTED, REJETEE, RELECTURE_EN_COURS, RELOU, RESET_REVIEW, REVIEWING, SALLE_CRLA, SALLE_CRLB, SALLE_MONTREAL, SALLE_RENE_CHAR, STATIQUE, VALIDATED, VALIDEE, WILL_NOT_REVIEW, drives, electricityConnections, reviewLabels, statusLabels, taskCategories };

//# sourceMappingURL=index.mjs.map